import {apiGet, apiPost} from "../../shared/api/client";

export const loadNotificationOperations = async () =>
    apiGet("/api/v2/admin/notifications/operations");

export const loadDeployerInbox = async () =>
    apiGet("/api/v2/admin/deployer/inbox");

export const acceptNotification = async (notificationId) =>
    apiPost(`/api/v2/admin/notifications/${notificationId}/accept`);

export const loadReviews = async () => apiGet("/api/v2/admin/reviews/list");

export const cancelReview = async (payload) => apiPost("/api/v2/admin/review/cancel", payload);
